import { cn } from '@wwe-portal/ui/lib/lib';
import { memo } from 'react';

const CircledIcon = ({
  icon,
  className,
}: Readonly<{ icon: string; className?: string }>) => {
  return (
    <div
      className={cn(
        'bg-back200 mb-2.5 flex size-[50px] items-center justify-center rounded-full',
        className
      )}
    >
      <img src={icon} alt="circle-icon" width={32} height={32} />
    </div>
  );
};

export default memo(CircledIcon);
